const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024 // 10 MB
const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp']

export class UploadImageError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'UploadImageError'
  }
}

export async function readUploadedImageAsDataUrl(file: File): Promise<string> {
  if (!ALLOWED_TYPES.includes(file.type)) {
    throw new UploadImageError('invalid_type')
  }
  if (file.size > MAX_FILE_SIZE_BYTES) {
    throw new UploadImageError('file_too_large')
  }

  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      const raw = reader.result as string
      // Normalize to JPEG so downstream always receives the same shape
      const img = new Image()
      img.onload = () => {
        // Tudo aqui dentro roda num callback ASSÍNCRONO: o que escapar não é
        // capturado por ninguém e deixa a promessa pendurada para sempre — o
        // convidado vê o upload girando sem erro, que é pior do que falhar.
        try {
          const canvas = document.createElement('canvas')
          canvas.width = img.width
          canvas.height = img.height
          // `!ctx` e não `instanceof CanvasRenderingContext2D`: o global pode
          // nem existir (WebView antiga, ambiente de teste), e aí o `instanceof`
          // LANÇA em vez de dar false. O contrato de `getContext` já é devolver
          // null quando não dá — é nele que dá para confiar.
          const ctx = canvas.getContext('2d')
          if (!ctx) {
            reject(new UploadImageError('canvas_unavailable'))
            return
          }
          ctx.drawImage(img, 0, 0)
          resolve(canvas.toDataURL('image/jpeg', 0.85))
        } catch {
          reject(new UploadImageError('canvas_unavailable'))
        }
      }
      img.onerror = () => reject(new UploadImageError('decode_failed'))
      img.src = raw
    }
    reader.onerror = () => reject(new UploadImageError('read_failed'))
    reader.readAsDataURL(file)
  })
}
